// ignore-string-externalization

import React from 'react';
import { ContentfulAsset } from '../../Contentful';
import { ModuleCarousel } from '../ModuleCarousel/ModuleCarousel';
import { ModuleComponentType, ModuleType } from '../types';

type HeroNarrativeCarouselModuleType = ModuleType & {
  id: string;
  title: string;
  headline: string;
  supertext: string;
  image: ContentfulAsset;
  carouselSlides: ModuleType[];
};

type HeroNarrativeCoverType = ModuleType & {
  id: string;
  title: string;
  headline: string;
  supertext: string;
  image: ContentfulAsset;
  textColor: string;
  backgroundColor: string;
};

// This is declared / changed to a higher order function / component in order to break the circular dependency,
// as part of an effort to remove all circular deps from mrkt-web

// Unfortunately, passing Module as a prop to the underlying component, here, is not straightforward,
// given how it's used. Basically, up in ../index.tsx there's a MODULE_COMPONENTS lookup, and whatever
// is found there is rendered, with the same set of props. And so special casing this would require some
// special care, which I don't really feel comfortable doing, not being very familiar with this code ajr 1/25/2022
export const heroNarrativeCarouselModuleCreator = (
  Module: ModuleComponentType,
) =>
  React.forwardRef<
    React.MutableRefObject<ModuleType>,
    HeroNarrativeCarouselModuleType
  >(
    (
      {
        id = '',
        title = '',
        headline = '',
        supertext = '',
        image,
        carouselSlides = [],
        textColor = '',
        backgroundColor = '',
        contentType = '',
        isVisible = false,
      },
      _,
    ) => {
      const coverSlide: HeroNarrativeCoverType = {
        id,
        title,
        contentType: 'heroCaseStudyCover',
        headline,
        supertext,
        image,
        textColor,
        backgroundColor,
      };
      const slides = [coverSlide, ...carouselSlides].filter(Boolean);

      return (
        <ModuleCarousel
          Module={Module}
          isHeader={false}
          carouselSlides={slides}
          contentType={contentType}
          title={title}
          isVisible={isVisible}
        />
      );
    },
  );
